import {Injectable, OnDestroy} from '@angular/core';

import {Injector} from '@angular/core';
import {Observable, interval, of, Subscription, Subject, timer, merge} from 'rxjs';
import {HttpService, autoSubscribe, takeUntilDestroyed} from 'projects/core/src/public-api';
import * as moment from 'moment';
import {EntityEventEmitter} from 'projects/core/src/lib/core/data/entities/entity-event-emitters';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {VacationEventsStore} from './vacation-events.store';
import {VacationEventsQuery} from './vacation-events.query';
import {DateRangeInput, EventInput, DatesSetArg} from '@fullcalendar/core';
import {environment} from 'projects/desktop/src/environments/environment';
import {VacationDay} from './vacation-day';
import {FcBrowserEvent} from '../../../../full-calendar/data/fc-browser-event';
import {repeatWhen} from 'rxjs/operators';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';


@Injectable({
  providedIn: 'root',
})
@RxJSUnsubscribe
export class VacationDaysService extends HttpService implements OnDestroy, RxJSUnsubscribable {
  vacationDayEmitter = new EntityEventEmitter<VacationDay>();

  eventsMap = new Map<string, VacationDay>();
  eventsElsMap = new Map<string, HTMLElement[]>();

  syncedSubj = new Subject<void>();

  eventLoadingSubs: Subscription;

  protected loadingEventsSubj = new Subject<boolean>();

  constructor(
    protected injector: Injector,
    protected vacationEventsStore: VacationEventsStore,
    protected vacationEventsQuery: VacationEventsQuery,
    protected appStateQuery: AppStateQuery,
    protected wsService: WsService
    // protected timeCardsStore: TimeCardsStore
  ) {
    super(injector);
  }

  getVacationDays(dateFrom: Date, dateTo: Date): Observable<VacationDay[]> {
    const startDate = moment(dateFrom).format('YYYY-MM-DD');
    const endDate = moment(dateTo).format('YYYY-MM-DD');
    return this.getData(`/time_card/list/vacation-requests/${startDate}:${endDate}`, VacationDay)
  }


  get loadingEvents$(): Observable<boolean> {
    return this.loadingEventsSubj
  }

  loadEventsForCalendar(dateRange: DateRangeInput) {
    this.vacationEventsStore.setLoading(true)

    if (this.eventLoadingSubs) {
      this.eventLoadingSubs.unsubscribe();
      this.eventLoadingSubs = null;
    }
    this.loadingEventsSubj.next(true);
    this.vacationEventsStore.set([]);
    this.eventLoadingSubs = this.getVacationDays(dateRange.start as Date, dateRange.end as Date)
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(vacationDays => {
        const events = [];
        vacationDays.forEach(vacationDay => {
          this.eventsMap.set('' + vacationDay.id, vacationDay)

          const eventData = {
            id: vacationDay.id,
            title: this.getVacationName(vacationDay),
            start: vacationDay.startTime,
            approved: vacationDay.approved,
            rejected: vacationDay.rejected,
            rejectReason: vacationDay.rejectReason,
            userId: vacationDay.user?.id,
            type: vacationDay.type,
            classNames: [`approved-${vacationDay.approved}`, `rejected-${vacationDay.rejected}`, `${vacationDay.type}-TYPE`]
          } as unknown as EventInput

          events.push(eventData)
        })
        this.vacationEventsStore.set(events)

        this.loadingEventsSubj.next(false)
      })

  }

  getVacationName(vacationDay: VacationDay) {
    return vacationDay.user.name
  }

  updateDateRange(info: DatesSetArg) {
    this.vacationEventsStore.updateDateRange(info.view.activeStart, info.view.activeEnd)
  }

  toggleVacationDay(dayIds: string): Observable<VacationDay> {
    return this.putData(`/time_card/list/vacation-requests/approve?ids=${dayIds}`, {}, VacationDay)
  }

  rejectVacationDay(dayIds: number[], rejectReason = 'No Reason'): Observable<VacationDay> {
    return this.putData(`/time_card/list/vacation-requests/reject?ids=${dayIds.join(',')}`, {
      // ids: dayIds,
      reason: rejectReason
    }, VacationDay)
  }

  requestVacationDay(userId: number, dates: string, type?: string): Observable<VacationDay> {
    return this.putData(`/time_card/request-vacation?userId=${userId}&dates=${dates}&type=${type}`, {}, VacationDay)
  }

  ngOnDestroy() {

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

}
